require('./ImportAmountInput.scss');
// @vendor
import React from 'react';
import PropTypes from 'prop-types';

// @ utilities
const { formatAmount } = require('utilities/currencyHelper');
const { formatText } = require('core/i18n').i18n;
const { recordLink, recordLinkV2 } = require("utilities/tagging");

// @components
import { AmountInput } from 'commonsComponents/amountInput';

// @constants
const {
    DEPOSIT_ERROR_EVENT_TAG,
    DEPOSIT_IMPORT,
    DEPOSIT_TEXTBOX,
    DEPOSIT_VIEW,
} = require('constants/tagging');

const { getLanguage } = require('core/i18n').i18n;

class ImportAmountInput extends React.Component {
    constructor(props) {
        super(props);
        let inputValue = props.amountToTransfer !== '' ? props.amountToTransfer : parseFloat(props.component.defaultValue);
        if (isNaN(inputValue)) {
            inputValue = '';
        }

        this.state = {
            inputValue: inputValue,
            error: props.balance !== undefined && props.balance < inputValue
        };
        this.handleInputBlur = this.handleInputBlur.bind(this);
        this.handleChangeInput = this.handleChangeInput.bind(this);
    }

    componentDidMount(){
        recordLink(this.props.categoryEvent, window.utag_last_name, DEPOSIT_VIEW);
    }

    componentDidUpdate(prevProps, prevState){
        const { amountToTransfer, component, balance } = this.props;
        const { importMin, importMax } = component;
        const maxAmount = importMax ? importMax : null;

        if ((prevProps.amountToTransfer !== amountToTransfer)) {
            this.setState({
                inputValue: amountToTransfer,
            });
        }
        if (prevState.inputValue !== this.state.inputValue) {
            if ((maxAmount && maxAmount > importMin) || !maxAmount) {
                this.setState({
                    error: balance !== undefined && balance < this.state.inputValue
                });
            }
        }
    }

    handleInputBlur(inputValue) {
        const {
            onChange,
            component,
            balance,
            categoryEvent,
            errorCategory
        } = this.props;
        const { errorMessage, importMin, importMax } = component;
        let value = inputValue;
        const maxAmount = importMax ? importMax : null;
        if ((maxAmount && maxAmount > importMin) || !maxAmount) {
            this.setState({
                inputValue: value,
                error: balance !== undefined && balance < value
            });
        }
        onChange(component, parseFloat(value));

        if (balance !== undefined && balance < value){
            const customData = ({
                categoriaEvento: categoryEvent,
                accionEvento: DEPOSIT_IMPORT,
                etiquetaEvento: DEPOSIT_ERROR_EVENT_TAG,
                descripcionError: formatText(errorMessage),
                ...(errorCategory && {categoriaError: errorCategory})
            });
            recordLinkV2(customData);
        }
    }

    handleChangeInput(evt) {
        const { inputType, component } = this.props;
        const { importMax } = component;
        const hasDecimals = inputType === 'formatWithDecimal';
        const inputValue = hasDecimals ? evt : evt.target.value.replace(/\D+/g, '');
        let value;

        if (hasDecimals) {
            value = formatAmount(inputValue, 'en', undefined, false);
        }
        const maxAmount = importMax ? importMax : null;
        if ((maxAmount && value <= importMax) || !maxAmount || inputValue === '') {
            this.setState({
                inputValue
            });
        } else {
            this.setState({
                inputValue: importMax
            });
        }
    }

    render() {
        const { inputType, categoryEvent } = this.props;
        const { inputValue, error } = this.state;
        const { format_type, importMin, importMax, infoMessage, errorMessage, errorMessageAmount } = this.props.component;
        
        const inlineUnit = inputValue !== '' ? format_type : '';
        const hasDecimals = inputType === 'formatWithDecimal';
        const maxAmount = importMax ? importMax : null;
        return (
            <div className="import-amount-input">
                <AmountInput
                    amount={inputValue}
                    callback={this.handleInputBlur}
                    disabled={false}
                    errorMsg={formatText(errorMessage, [errorMessageAmount])}
                    error={error}
                    fluid={true}
                    inlineUnit={inlineUnit}
                    instructionsMessage={infoMessage}
                    handleOnFocus={() => recordLink(categoryEvent, DEPOSIT_IMPORT, DEPOSIT_TEXTBOX)}
                    language={getLanguage()}
                    max={parseFloat(maxAmount)}
                    maxFractionLength={hasDecimals ? 2 : 0}
                    min={parseFloat(importMin)}
                    onChange={this.handleChangeInput}
                    removeDecimals={false}
                    showBlurZero={inputValue == 0}
                />
            </div>
        )
    }
}

ImportAmountInput.defaultProps = {
    categoryEvent: '',
    errorCategory: '',
};

ImportAmountInput.propTypes = {
    id: PropTypes.string,
    categoryEvent: PropTypes.string,
    component: PropTypes.object,
    errorCategory: PropTypes.string,
    onChange: PropTypes.func,
    inputType: PropTypes.string,
    amountToTransfer: PropTypes.string,
    balance: PropTypes.number,
};

module.exports = ImportAmountInput;
